import wcShared from '@web-components/shared';

import { CallmebackReservation, CallmebackReservations } from '../callmeback.type';

class CallmebackService {
  private async _fetch(method: IHttpMethod = 'GET', url: string, body = null) {
    let response: Response;
    if (body) response = await wcShared?.httpCall(method, url, body);
    else response = await wcShared.httpCall(method, url);
    const responseBody = await response.json();
    if (!response.ok) {
      throw new Error(responseBody.error.code);
    }
    return responseBody.data;
  }

  deleteReservation(token: string) {
    return this._fetch('DELETE', `/api/web-components/1/chatbot/call_me_back/${token}`);
  }

  postReservation(body: object = null): Promise<void> {
    return this._fetch('POST', '/api/web-components/1/chatbot/call_me_back', body);
  }

  patchReservation(token: string, body: object = null): Promise<void> {
    return this._fetch('PATCH', `/api/web-components/1/chatbot/call_me_back/${token}`, body);
  }

  getReservations(token: string): Promise<CallmebackReservations[]> {
    return this._fetch(
      'GET',
      `/api/web-components/1/chatbot/call_me_back/reservations${
        Boolean(token) ? '?token=' + token : ''
      }`,
    );
  }

  getReservationByToken(token: string): Promise<CallmebackReservation> {
    return this._fetch('GET', `/api/web-components/1/chatbot/call_me_back/${token}`);
  }
}

export default new CallmebackService();
